import { PracticalExam, TheoryExam } from "../model/autovioCalendarEvents";
import { Student } from "../providers/studentsProvider";

export function getTheoryExamAttempt(event: TheoryExam, student: Student): number | undefined {
  const sortedTheoryExams = Object.entries(student.theoryKPIs?.theoryExams ?? {})
    .filter(([_, value]) => value.rsvp && ["pending", "accepted"].includes(value.rsvp))
    .sort((a, b) => a[1].date.toMillis() - b[1].date.toMillis());
  return sortedTheoryExams.findIndex(([key]) => key === event.id) + 1 || undefined;
}

export function getPracticalExamAttempt(event: PracticalExam, student: Student): number | undefined {
  const bookedTraining = student.bookedTrainings.find(
    (bookedTraining) => bookedTraining.id === event.student.bookedTrainingId,
  );
  if (bookedTraining) {
    const sortedPracticalExams = Object.entries(bookedTraining.kpis?.practicalExams ?? {})
      .filter(([_, value]) => value.rsvp && ["pending", "accepted"].includes(value.rsvp))
      .sort((a, b) => a[1].date.toMillis() - b[1].date.toMillis());
    return sortedPracticalExams.findIndex(([key]) => key === event.id) + 1 || undefined;
  }
  return undefined;
}
